export default {
  loggedIn: {
    deposit: 'Deposit',
    withdraw: 'Pengeluaran',
    balance: 'Jumlah Baki',
    cash: 'Tunai',
    bonus: 'Bonus',
    withdrawable: 'Boleh Dikeluarkan',
    transaction: 'Transaksi',
    history: 'Sejarah',
    myBet: 'My Bet',
    rollover: 'Rollover',
    vault: 'Peti Besi',
    notification: 'Pemberitahuan',
    affiliate: 'Ahli Gabungan - Peroleh $5,000 Sebulan',
    affiliateTitle: 'Ahli Gabungan',
    affiliateBadge: 'Peroleh $5,000 Sebulan',
    settings: 'Tetapan',
    currency: 'Mata Wang',
    language: 'Bahasa',
    liveSupport: 'Sokongan Langsung',
    signOut: 'Log keluar'
  }
};
